export enum NotificationType {
  Fail = 1,
  Success = 2,
  Info = 3,
  Warn = 4,
  SuccessWithReportId = 5,
  Toast=6
}
